// Set REACT_APP_GOOGLE_PLACE_ID in .env for the direct Google review form URL.
// Find it in Google Business Profile → Share review form, or from your Maps listing URL.
import { SITE_URL } from '../config/site';

const GOOGLE_PLACE_ID = process.env.REACT_APP_GOOGLE_PLACE_ID || '';

const GOOGLE_BUSINESS_NAME = 'Mori Tours';
const GOOGLE_MAPS_QUERY = 'Mori Tours Arusha Tanzania moritours.com';

export function getGoogleWriteReviewUrl() {
  if (GOOGLE_PLACE_ID) {
    return `https://search.google.com/local/writereview?placeid=${encodeURIComponent(GOOGLE_PLACE_ID)}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(GOOGLE_MAPS_QUERY)}`;
}

export function getGoogleProfileUrl() {
  if (GOOGLE_PLACE_ID) {
    return `https://www.google.com/maps/place/?q=place_id:${encodeURIComponent(GOOGLE_PLACE_ID)}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(GOOGLE_MAPS_QUERY)}`;
}

export function getLocalBusinessReviewSchema(reviewCount = 3, ratingValue = 5) {
  return {
    '@context': 'https://schema.org',
    '@type': 'TravelAgency',
    name: GOOGLE_BUSINESS_NAME,
    url: SITE_URL,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Arusha',
      addressCountry: 'TZ',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: String(ratingValue),
      reviewCount: String(reviewCount),
      bestRating: '5',
      worstRating: '1',
    },
    sameAs: [getGoogleProfileUrl()],
  };
}
